// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__HbqhL","navbarScrollCustom":"carroFicha_navbarScrollCustom__7yLeB","rectangle":"carroFicha_rectangle__-mUMF"};